// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e6f0eeef","498":"5df004bd","703":"193a95ce","787":"31221ef2"}[chunkId] + ".chunk.js";
};